import React from 'react';
// SİHİRLİ KOD: useLocation'ı buraya ekledik!
import { Link, useLocation } from 'react-router-dom'; 
import logo from '../logo.png'; 

function Footer() {
  const location = useLocation();

  // SİHİRLİ KOD: Eğer URL '/admin' içeriyorsa Footer kendini imha eder (gizlenir)
  if (location.pathname.includes('/admin')) {
    return null;
  }

  return (
    <footer className="footer-section">
      <div className="footer-container">
        
        {/* 1. Sütun: Logo ve Vizyon */}
        <div className="footer-col brand-col">
          <Link to="/">
            <img src={logo} alt="Demir Grup Logo" className="footer-logo" />
          </Link>
          <p>Ankara'dan başlayarak tüm Türkiye'de güvenliğin ve altyapının standartlarını belirleyen, evrensel teknoloji ortağınız.</p>
        </div>

        {/* 2. Sütun: Kurumsal Linkler */}
        <div className="footer-col">
          <h4>Kurumsal</h4>
          <ul>
            <li><Link to="/">Ana Sayfa</Link></li>
            <li><Link to="/hakkimizda">Hakkımızda</Link></li>
            <li><Link to="/hizmetlerimiz">Tüm Hizmetler</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>
            <li><Link to="/projeler">Projeler</Link></li>
          </ul>
        </div>

        {/* 3. Sütun: Odak Hizmetler */}
        <div className="footer-col">
          <h4>Ürünlerimiz</h4>
          <ul>
            <li><Link to="/kamera">Güvenlik Kameraları</Link></li>
            <li><Link to="urunler/guvenlik-fileleri">Güvenlik Fileleri</Link></li>
            <li><Link to="urunler/is-guvenligi">İş Güvenliği Ekipmanları</Link></li>
            <li><Link to="urunler/zayif-akim">Zayıf Akım Sistemleri</Link></li>
          </ul>
        </div>

        {/* 4. Sütun: Gerçek İletişim Bilgileri */}
        <div className="footer-col contact-col">
          <h4>Bize Ulaşın</h4>
          <ul>
            <li>
              <span className="footer-icon">📍</span> 
              <div>Malazgirt Mah. Buhara Cad.<br/>71/C Sincan / ANKARA</div>
            </li>
            <li>
              <span className="footer-icon">📞</span> 
              <div>0530 509 06 31<br/>0545 416 71 41</div>
            </li>
            <li>
              <span className="footer-icon">✉️</span> 
              <div>ddemirgrup@gmail.com</div>
            </li>
          </ul>
        </div>

      </div>

      {/* En Alt Kısım: Telif Hakkı ve Sosyal Medya */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Demir Grup İnşaat & Güvenlik Sistemleri. Tüm Hakları Saklıdır.</p>
        <div className="social-links">
          <a href="#">Instagram</a>
          <a href="#">LinkedIn</a>
          <a href="#">WhatsApp</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;